import balance from "@/store/game/balance.store";
import bummers from "@/store/game/bummers/list.store";
import hints from "@/store/game/hints.store";
import insurance from "@/store/game/insurance/list.store";
import rounds from "@/store/game/rounds/list.store";
import plans from "@/store/game/plans/list.store";
import risk from "@/store/game/risk.store";
import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { START_GAME, COMPLETE_GAME, PAUSE_GAME, UNPAUSE_GAME } = LOCAL;

export default {
	namespaced: true,
	modules: {
		balance,
		bummers,
		hints,
		insurance,
		plans,
		rounds,
		risk,
	},
	state: {
		active: false,
		complete: false,
		paused: false,
		outcome: '',
	},
	getters: {
		determineOutcome: (state, getters, rootState) => {
			let result = 'lose';
			result = rootState.game.balance.amount > 0 ? 'win' : result;
			result = rootState.game.balance.amount <= 0 ? 'lose' : result;
			return result;
		},
	},
	actions: {
		start({ commit }) {
			commit(START_GAME);
			// This seems to be properly called on rounds/list/configureApp 100% of the time,
			// where as this currently only gets called if you actually start the game from scratch
			// leaving this in causes the round to activate twice, which, maybe is fine, but isn't right.
			// this is the _correct_ place for this to be called, but I'm disabling it for now in the
			// interest of getting something playable out
			// dispatch("rounds/activate", { index: 0 });
		},
		end({ dispatch, commit, getters }) {
			dispatch("game/plans/reset", {}, ROOT_FLAG);
			commit(COMPLETE_GAME, { outcome: getters.determineOutcome });
		},
		pause({ commit }) {
			commit(PAUSE_GAME);
		},
		unpause({ commit }) {
			commit(UNPAUSE_GAME);
		},
	},
	mutations: {
		[START_GAME](state) {
			state.active = true;
		},
		[COMPLETE_GAME](state, { outcome }) {
			state.active = false;
			state.complete = true;
			state.outcome = outcome;
		},
		[PAUSE_GAME](state) {
			state.paused = true;
		},
		[UNPAUSE_GAME](state) {
			state.paused = false;
		},
	},
};
